import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "Is it safe for my child to use?",
    a: "Accounts belong to parents and guardians. There are no child-to-child accounts, no private messaging, and every post and photo is moderated. Kids enjoy the content; grown-ups control the community.",
  },
  {
    q: "What ages is it designed for?",
    a: "Content is created for children ages 2–10, with categories that grow with your family — from gentle lullabies for toddlers to Bible adventures for older kids.",
  },
  {
    q: "Can I control what my family sees and shares?",
    a: "Yes. Privacy controls let you make your account private, hide family photos from public discovery and turn comments off on your posts. Child profiles are always private and visible only to you.",
  },
  {
    q: "Who can see the community posts?",
    a: "Every post and photo is reviewed by our moderation team before it appears publicly. Parents can report or block anything that doesn't feel right, and our team acts on every report.",
  },
];

const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      className="relative flex min-h-[100svh] flex-col justify-center py-24"
      data-testid="faq-section"
    >
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6">
        <div className="text-center">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#0284C7]">Good to know</p>
          <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            Questions parents ask
          </h2>
        </div>
        <div className="mt-10 space-y-3" data-testid="faq-list">
          {FAQS.map((f, i) => (
            <motion.div
              key={f.q}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="overflow-hidden rounded-2xl border border-[#E2DDD0] bg-white"
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                data-testid={`faq-question-${i}`}
                className="flex w-full items-center justify-between gap-4 px-6 py-4 text-left font-display text-base font-semibold text-slate-900"
              >
                {f.q}
                <motion.span animate={{ rotate: open === i ? 180 : 0 }}>
                  <ChevronDown className="h-5 w-5 text-slate-400" />
                </motion.span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                  >
                    <p className="px-6 pb-5 text-sm text-slate-600 leading-relaxed" data-testid={`faq-answer-${i}`}>
                      {f.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
